import React from 'react';
import { Button, Text } from 'v3/components';

export default function DeletePointModal({ isOpen = false, onCancel, onConfirm }) {
	if (!isOpen) return null;

	return (
		<div
			style={{
				position: 'fixed',
				top: 0,
				left: 0,
				width: '100vw',
				height: '100vh',
				backgroundColor: 'rgba(0, 0, 0, 0.5)',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				zIndex: 9999,
			}}
		>
			<div
				style={{
					backgroundColor: 'white',
					padding: '2rem',
					borderRadius: '8px',
					width: '400px',
					textAlign: 'center',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
				}}
			>
				<Text
					type="header"
					style={{
						fontSize: '1.5rem',
						fontWeight: '700',
						marginBottom: '1rem',
					}}
				>
					Confirmar Exclusão
				</Text>

				<div
					style={{
						width: '100%',
						height: '1px',
						backgroundColor: '#dee2e6',
						marginBottom: '1.5rem',
					}}
				/>

				<Text
					style={{
						marginBottom: '2rem',
						fontSize: '1rem',
						color: '#555',
					}}
				>
					Tem certeza que deseja excluir este ponto de interesse?
				</Text>

				<div
					style={{
						width: '100%',
						height: '1px',
						backgroundColor: '#dee2e6',
						marginBottom: '1.5rem',
					}}
				/>

				<div
					style={{
						display: 'flex',
						justifyContent: 'flex-end',
						gap: '1rem',
						width: '100%',
					}}
				>
					<Button variant="secondary" onClick={onCancel}>
						Cancelar
					</Button>
					<Button variant="error" onClick={onConfirm}>
						Excluir
					</Button>
				</div>
			</div>
		</div>
	);
}
